import { render } from "./BuildingCard.vue?vue&type=template&id=c0801c62&scoped=true"
import script from "./BuildingCard.vue?vue&type=script&lang=js"
export * from "./BuildingCard.vue?vue&type=script&lang=js"

import "./BuildingCard.vue?vue&type=style&index=0&id=c0801c62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0801c62"]])

export default __exports__